import { HoverCard, HoverCardContent, HoverCardTrigger } from "~/components/shared/HoverCard";
import { formatTooltipDateString } from "~/components/ClustersInsights/Chart/utils";

export function Tooltip({ tooltip, children }) {
  const dateString = formatTooltipDateString(tooltip.dataPoints[0].parsed.x);

  return (
    <HoverCard open={true}>
      <HoverCardTrigger />
      <HoverCardContent
        side="right"
        className="grid w-auto grid-cols-[auto_auto] gap-x-3 gap-y-0.5 px-2 py-2.5 text-xs"
      >
        <div className="col-span-2 font-semibold">{dateString}</div>
        {children}
      </HoverCardContent>
    </HoverCard>
  );
}

export function TooltipLabel({
  children,
  color,
}: React.HTMLAttributes<HTMLSpanElement> & { color?: string }) {
  return (
    <span className="text-charcoal-300 font-semibold" style={{ color }}>
      {children}
    </span>
  );
}

export function TooltipValue({ children }: React.HTMLAttributes<HTMLSpanElement>) {
  return <span className="text-right">{children}</span>;
}
